import { defaultTo } from 'ramda';

import { IAppState } from '../../../AppModulesWrapper';

import { selectMicrofrontendHostName } from '../../../Microfrontend';

import {
  selectBusinessCenterId,
  selectCurrency,
  selectIsArchived,
  selectIsAreaParts,
  selectIsBusinessCenterCategory,
  selectIsByHomeowner,
  selectIsJKCategory,
  selectJKHouseId,
  selectJKId,
  selectLocationIds,
  selectOfferCategory,
  selectOfferCoordinates,
  selectOfferId,
  selectPhotos,
} from '../offer';
import { IAddFormPublishTermsRequest } from '../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { getIsCommercial } from '../../utils/category/getIsCommercial';
import { selectTotalArea } from '../offer/selectTotalArea';
import { selectPrice } from '../offer/selectPrice';
import { selectPriceType } from '../offer/selectPriceType';
import { selectPaymentPeriod } from '../offer/selectPaymentPeriod';
import { selectDynamicPricingData } from '../dynamicPricing';
import { selectPlacingMoneySource } from './selectPlacingMoneySource';
import { getMultiListingSlotsCount } from '../../utils/commercialMultiAds/getMultiListingSlotsCount';
import { selectAreaParts } from '../offer/selectAreaParts';
import { selectActivePlacingType, selectPublicationTokens } from '.';
import { EPlacingType } from '../../types/reducers/publishTerms';
import { selectConfigValue } from '../config';
import {
  ECategory,
  EHostName,
  EUiType,
} from '../../repositories/billing-tariffs/entities/PublishTerms/GetPublishTermsRequest';

export const selectPublishTermsRequestParameters = (state: IAppState): IAddFormPublishTermsRequest => {
  const id = selectOfferId(state);
  const category = selectOfferCategory(state);
  const photos = selectPhotos(state);
  const isMultiListing = selectIsAreaParts(state);
  const areaParts = selectAreaParts(state);
  const locationPath = selectLocationIds(state);
  const { lat, lng } = selectOfferCoordinates(state);
  const isJKCategory = selectIsJKCategory(state);
  const isBusinessCenterCategory = selectIsBusinessCenterCategory(state);
  const newObjectId = selectJKId(state);
  const newObjectHouseId = selectJKHouseId(state);
  const businessShoppingCenterId = selectBusinessCenterId(state);
  const isFromArchive = selectIsArchived(state);
  const totalArea = selectTotalArea(state);
  const price = selectPrice(state);
  const currency = selectCurrency(state);
  const priceType = selectPriceType(state);
  const paymentPeriod = selectPaymentPeriod(state);
  const moneySource = selectPlacingMoneySource(state);
  const extraData = selectDynamicPricingData(state);
  const isByHomeowner = selectIsByHomeowner(state);
  const hostName = selectMicrofrontendHostName(state);
  const publicationTokens = selectPublicationTokens(state);

  const parameters = {
    ...(isJKCategory && { newObjectId, newObjectHouseId }),
    ...(isBusinessCenterCategory && { businessShoppingCenterId }),
    ...(id && { id }),
    category: category as string as ECategory,
    photosCount: photos.length,
    locationPath: [...locationPath].reverse(),
    latitude: lat,
    longitude: lng,
    isMultiListing,
    isFromArchive,
    moneySource,
    extraData,
    isByHomeowner,
    uiType: EUiType.WebView,
    hostName: hostName as string as EHostName,
    publicationToken: defaultTo(null, publicationTokens.publicationToken),
  };

  const isCommercial = getIsCommercial(category);
  const activePlacingType = selectActivePlacingType(state);
  /**
   * @todo Удалить строку с RS
   * @description Данный функционал появился в задаче CD-155300, будет удалён в задаче CD-155303
   */
  const diffPricesPackageEnabled = selectConfigValue('diffPricesPackageEnabled', state);

  const isPackageOnUi = activePlacingType ? activePlacingType === EPlacingType.package : null;

  if (isCommercial) {
    Object.assign(parameters, {
      price,
      currency,
      priceType,
      paymentPeriod,
      totalArea,
      multiListingSlotsCount: getMultiListingSlotsCount(areaParts),
      /**
       * @todo Удалить условие с RS
       * @description Данный функционал появился в задаче CD-155300, будет удалён в задаче CD-155303
       */
      ...(diffPricesPackageEnabled && { isPackageOnUi }),
    });
  }

  return parameters;
};
